import React from "react";
import Auth from "../services/auth";

class ResponsiveLogout extends React.Component {
  componentDidMount() {
    Auth.logout("/");
  }
  render() {
    return null;
  }
}

export default ResponsiveLogout;
